import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  placeholderText?: string;
  style?: React.CSSProperties;
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ 
  src, 
  alt, 
  className = "", 
  placeholderText = "Image Placeholder",
  style
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div className={`bg-gray-200 border-2 border-dashed border-gray-400 flex items-center justify-center text-gray-500 ${className}`}>
        <div className="text-center">
          <div className="text-4xl mb-2">📷</div>
          <div className="text-sm font-medium">{placeholderText}</div>
          <div className="text-xs text-gray-400 mt-1">Click to add image</div>
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setHasError(true)}
    />
  );
};

export default ImageWithFallback;